/**
 * @desc sku报价创建
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierQuotationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
